import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 17h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2m0-13h8v11h-8zM8 19h6v2H8c-1.1 0-2-.9-2-2V8h2zm-4 4h6v2H4c-1.1 0-2-.9-2-2V12h2zm26 1l-6 6l-1.4-1.4l3.6-3.6H17v-2h9.2l-3.6-3.6L24 18z"
    }, null, -1)
  ]))]))
}
export default { render: render }